import {
  HOST_TO_COUNTRY,
  LOCALIZED_HOST_SET,
  MULTI_COUNTRY_HOSTS,
  PRIMARY_HOSTS,
} from "@constants/localizedHosts"

export type ResolvedDomain = {
  countries?: string[]
  country?: string
  host: string
  isLocalized: boolean
  isPrimary: boolean
}

export function pickDomainCountry(
  resolved: ResolvedDomain,
  explicit?: string
): string | undefined {
  if (explicit) return explicit.toUpperCase()
  return resolved.isLocalized ? resolved.country : undefined
}

export function resolveDomainCountry(hostname?: string): ResolvedDomain {
  const host = resolveHostname(hostname)

  if (!host || PRIMARY_HOSTS.has(host)) {
    return { host, isLocalized: false, isPrimary: true }
  }

  if (LOCALIZED_HOST_SET.has(host)) {
    const multi = MULTI_COUNTRY_HOSTS[host]
    if (multi?.length) {
      return {
        countries: multi,
        country: multi[0],
        host,
        isLocalized: true,
        isPrimary: false,
      }
    }
    const single = HOST_TO_COUNTRY[host]
    return {
      countries: single ? [single] : undefined,
      country: single,
      host,
      isLocalized: true,
      isPrimary: false,
    }
  }

  return { host, isLocalized: false, isPrimary: true }
}

export function resolveHostname(explicit?: string, fallback = ""): string {
  if (explicit && explicit.trim()) return normalize(explicit)

  if (typeof window !== "undefined" && window.location?.hostname) {
    return window.location.hostname.toLowerCase()
  }
  return fallback.toLowerCase()
}

function normalize(input: string): string {
  const raw = input.trim().toLowerCase()

  try {
    if (raw.includes("://")) {
      return new URL(raw).hostname.toLowerCase()
    }

    if (raw.includes("/") || raw.includes("\\")) {
      return new URL(`http://${raw}`).hostname.toLowerCase()
    }
  } catch {
    // no-op
  }

  // Strip port if present (e.g., "host:8888")
  const hostOnly = raw.split(":")[0]
  // Remove surrounding brackets for IPv6 like "[::1]"
  return hostOnly.replace(/^\[|\]$/g, "")
}
